import { Component, Input, OnInit } from '@angular/core'; // Import OnInit
import { ModalController } from '@ionic/angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-referral-upload-modal',
  template: `
    <ion-header>
      <ion-toolbar class="modal-header">
        <h3>{{ title }}</h3>
        <ion-buttons slot="end">
          <ion-button role="button" class="text-base" (click)="dismiss()">
            <ion-icon name="close" aria-hidden="true"></ion-icon>
            Close
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="modal-content custom-modal">
      <div class="px-6 content-wrap mt-4 mb-4">
        <p class="mt-2" [innerHTML]="safeMessage"></p>
        <!-- Bind the sanitized HTML here -->
        <div class="mt-4 mb-5">
          <ion-button role="button" class="tertiaryBtn" fill="clear" expand="block" (click)="dismiss()">
            OK
          </ion-button>
        </div>
      </div>
    </ion-content>
  `,
})
export class ReferralUploadModalComponent implements OnInit {
  @Input() title = ''; // Removed explicit type annotation
  @Input() message = ''; // Removed explicit type annotation

  safeMessage: SafeHtml = ''; // Property to hold the sanitized HTML message

  constructor(private modalCtrl: ModalController, private sanitizer: DomSanitizer) {}

  ngOnInit() {
    // Sanitize the HTML content to safely display it in the modal
    this.safeMessage = this.sanitizer.bypassSecurityTrustHtml(this.message);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
